import ClosureSurveyData from 'sprockets_react/closure_survey/data/registry'
import { EventEmitter } from 'events'

ClosureSurveyData.Store = new EventEmitter();

ClosureSurveyData.Store.dispatchToken = ClosureSurveyData.Dispatcher.register(function(payload) {
  switch (payload.type) {
    case 'data:closure_survey:reset':
      ClosureSurveyData.Data = ClosureSurveyData.seedData()
      break;
  }
})
